/**
 * Turns an unknown error into an Error
 * @param error
 */
export const errorify: (error: unknown) => Error = (error: unknown) => {
	if (error instanceof Error) {
		return error;
	}
	if (typeof error === "string") {
		return new Error(error);
	}
	if (typeof error === "undefined") {
		return new Error("undefined");
	}
	return new Error(JSON.stringify(error));
};
